/* Skullette FALL CLEARANCE claim-deal LP — "⚡ Happening inside right now" teaser. Ported slot logic from the
 * live collection's skullette-fall-clearance-lightning-rotation.js: slot = floor(now/30000) % N over the
 * shared skullette-fall-clearance-rotation.json, skip to the next available item once /products/<handle>.js
 * confirms the featured variant is sold out. Unlike the live collection, price is never shown here — always
 * "🔒 Claim your deal to unlock" (this is a teaser, not a cart). A 30s berry ring stays synced to the slot
 * boundary (overlaid top-right of the product image, per the mockup), with a brief slide transition +
 * "You just missed: <previous>" on every rotation. Needs window.SFD (core module, loaded first).
 */
(function () {
  var A = window.SFD;
  if (!A) return;
  var root = A.root;
  var card = root.querySelector('[data-sfd-live-card]');
  if (!card) return;
  var imgEl = root.querySelector('[data-sfd-live-img]');
  var titleEl = root.querySelector('[data-sfd-live-title]');
  var dealEl = root.querySelector('[data-sfd-live-deal]'), pctEl = root.querySelector('[data-sfd-live-pct]'), wasEl = root.querySelector('[data-sfd-live-was]');
  var missedEl = root.querySelector('[data-sfd-missed]');
  var missedNameEl = root.querySelector('[data-sfd-missed-name]');
  var ringFg = root.querySelector('[data-sfd-ring-fg]');
  var ringNumEl = root.querySelector('[data-sfd-ring-num]');
  var CIRC = 2 * Math.PI * 44;
  if (ringFg) { ringFg.style.strokeDasharray = CIRC; ringFg.style.strokeDashoffset = 0; }

  var ITEMS = null, N = 0;
  var SOLD = {};
  var shownIdx = null, prevItem = null;

  function cleanTitle(t) { return String(t).replace(/\s*-?\s*FALL\s*CLEARANCE\s*DEAL\s*$/i, '').replace(/\s+/g, ' ').trim(); }
  function img(src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

  function baseSlot() { return Math.floor(Date.now() / 30000) % N; }
  function pick(from) {
    for (var k = 0; k < N; k++) { var idx = (from + k) % N; if (SOLD[ITEMS[idx].handle] !== false) return idx; }
    return from;
  }
  function slotEndsAt() { return (Math.floor(Date.now() / 30000) + 1) * 30000; }

  function load() {
    fetch(root.dataset.sfdRotation, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { ITEMS = j; N = j.length; tick(); setInterval(tick, 250); })
      .catch(function () { if (titleEl) titleEl.textContent = 'Lightning deals are loading slowly — please refresh.'; });
  }

  function tick() {
    if (!ITEMS || !N) return;
    var idx = pick(baseSlot());
    if (idx !== shownIdx) {
      if (shownIdx !== null) prevItem = ITEMS[shownIdx];
      shownIdx = idx;
      render(idx);
    }
    updateRing();
  }

  function render(idx) {
    var it = ITEMS[idx];
    var swap = function () {
      if (imgEl) { imgEl.src = img(it.image, 300); imgEl.alt = cleanTitle(it.title); }
      if (titleEl) titleEl.textContent = cleanTitle(it.title);
      // was-price of the live slot (rotation.json compare_at) — FOMO without revealing the sale price or its %
      var p = Number(it.price), c = Number(it.compare_at);
      if (dealEl && wasEl && c > p && p > 0) {
        // no % pill on purpose: the page claim can be the 55 arm while a Lightning slot is 60% off (anh 10-13)
        if (pctEl) pctEl.hidden = true;
        wasEl.textContent = '$' + c.toFixed(2);
        dealEl.hidden = false;
      } else if (dealEl) dealEl.hidden = true;
      if (missedEl && missedNameEl) {
        if (prevItem) { missedNameEl.textContent = cleanTitle(prevItem.title); missedEl.hidden = false; }
        else missedEl.hidden = true;
      }
      card.classList.remove('is-sliding');
    };
    if (A.reducedMotion) { swap(); } else {
      card.classList.add('is-sliding');
      setTimeout(swap, 180);
    }
    fetchLive(it, idx);
  }

  function fetchLive(it, idx) {
    fetch('/products/' + it.handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var featured = p.variants.filter(function (v) { return v.id === it.featured_variant_id; })[0];
        SOLD[it.handle] = featured ? featured.available : false;
        if (shownIdx === idx && SOLD[it.handle] === false) { shownIdx = null; tick(); }
      })
      .catch(function () {});
  }

  function updateRing() {
    if (!ringFg || !N) return;
    var remain = slotEndsAt() - Date.now();
    var frac = Math.max(0, Math.min(1, remain / 30000));
    ringFg.style.strokeDashoffset = CIRC * (1 - frac);
    if (ringNumEl) ringNumEl.textContent = Math.max(1, Math.ceil(remain / 1000));
  }

  load();
})();
